<!-- 修改密码 -->
<template>
  <div class="container containerBox">
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      class="change-from"
      :rules="rules"
    >
        <div class="container-title">修改密码</div>
      <el-form-item label="更改密码" prop="newPassword">
        <el-input type="password" v-model="form.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="reNewPassword">
        <el-input type="password" v-model="form.reNewPassword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
const jsSHA = require("jssha");

export default {
    name: "changepassword",
    inject: ["reload"],
    data() {
        return {
            form: {},
            rules: {
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                ],
                reNewPassword: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                ]
            }
        };
    },
    computed: {
        // 项目列表
        ...mapGetters(["user"])
    },
    methods: {
        onSubmit() {
            this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    if(this.form.newPassword == this.form.reNewPassword) {
                        let shaObj = new jsSHA("SHA-512", "TEXT");
                        shaObj.update(this.form.newPassword);
                        // 登录参数
                        let parms = {};
                        parms.oid = this.user.oid;
                        parms.password = shaObj.getHash("HEX");
                        let data = await Service.editPwd(parms);
                        if(data) {
                            this.$message({
                                type: 'success',
                                message: '操作成功,请重新登录!', 
                                duration: 1500,
                                onClose: ()=> {
                                    this.$store.dispatch("LogOut").then(()=> {
                                        // this.$router.push("/login");
                                        location.href = '/login'
                                    })
                                }
                            });
                        }
                    }else{
                        this.$notify({
                            title: '提示',
                            message: '两次密码输入不同，请检查密码！',
                            type: 'warning'
                        });
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang='css' scoped>
.change-from{
    width: 500px;
    margin: 0 auto ;
}
</style>